.bubble-node {
    // --aura-color: null;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform-origin: center center;
    will-change: transform; // Hint para el navegador
    user-select: none; // Evitar selección de texto al arrastrar
    cursor: grab;
    // box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); // DEBUG: para ver los bordes de la burbuja

    transition: box-shadow 0.18s ease, top 0.18s ease, filter 0.18s ease;

    &.selected {
        filter: saturate(140%) brightness(1.04);
        z-index: var(--z-index-bubble-selected);
        box-shadow:
            0 14px 25px rgba(11, 11, 11, 0.32),
            0 0 0 0px rgba(255, 255, 255, 0.9),
            0 0 8px 2px var(--aura-color, #4285f4);
        top: -6px;

        // Anillo pulsante: refuerza la selección de forma notoria sin interferir
        // con el transform inline que AbstractEntity aplica cada frame al host.
        &::after {
            content: '';
            position: absolute;
            inset: -6px;
            border-radius: 50%;
            border: 2px solid var(--aura-color, #4285f4);
            opacity: 0.75;
            pointer-events: none;
            animation: selected-ring-pulse 1.8s ease-out infinite;
        }

        // .selected-element-mask {
        //     --mask-scale: 1;
        //     display: none;
        //     position: absolute;
        //     left: 0px;
        //     width: 100%;
        //     height: 100%;
        //     fill: var(--aura-color);
        //     z-index: 1;
        //     animation: rotate-only 70s linear infinite;
        //     filter: contrast(0.6) drop-shadow(0 0 2px var(--aura-color)) blur(0.1px);

        //     @keyframes rotate-only {
        //         100% {
        //             transform: rotate(360deg) scale(var(--mask-scale));
        //         }

        //         0% {
        //             transform: rotate(0deg) scale(var(--mask-scale));
        //         }
        //     }
        // }

        @keyframes selected-ring-pulse {
            0% {
                transform: scale(0.92);
                opacity: 0.8;
            }

            70% {
                transform: scale(1.25);
                opacity: 0;
            }

            100% {
                transform: scale(1.25);
                opacity: 0;
            }
        }
    }

    &:not(.selected) {
        z-index: var(--z-index-bubble-unselected);
    }

    &.trapped {
        // Estilos extra para burbuja atrapada
        box-shadow: 0 0 4px 2px var(--aura-color);
    }

    &:active {
        cursor: grabbing;
        // >* { transform: scale(1.05); // Escala ligeramente al arrastrar }
    }

    // Indicador visible de foco para navegación por teclado (Tab + Enter/Espacio)
    &:focus-visible {
        outline: 3px solid #4285f4;
        outline-offset: 3px;
    }

    &[aria-disabled="true"] {
        cursor: default;
    }

    app-avatar-alumno {
        pointer-events: none; // El clic debe pasar a la burbuja, no al avatar
    }
}